/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { ReactNode } from "react";

import "./DropdownScrollableArea.scss";

interface DropdownScrollableAreaProps {
  children: ReactNode;
}

export const DropdownScrollableArea = (props: DropdownScrollableAreaProps) => {
  const { children } = props;

  return <a className="DropdownScrollableArea">{children}</a>;
};
